/**
 * Formats a phone number to what cognito uses
 * @param phoneNumber phone number in the format
 */
export function generateCognitoPhoneFormat(phoneNumber){
    let phoneWithoutSpecialCharacters:string = phoneNumber.replace(/\D/g,'');

    let cognitoPhoneFormat = "+";
    if(phoneWithoutSpecialCharacters.length == 10){
        cognitoPhoneFormat += "1";
    }
    cognitoPhoneFormat += phoneWithoutSpecialCharacters
    
    return cognitoPhoneFormat;
}